import { Datakatalog } from '@/bootstrap/data';
import {
    getHoydereferanseText,
    Vegobjekt,
    VegobjektEgenskapKvalitetAttributt,
} from '@/domain/vegobjekter/Vegobjekt';
import { statePreferences } from '@/selectors/selectors';
import { interpretQuality } from '@/utils/Utils';
import React from 'react';
import { useSelector } from 'react-redux';
import Expand from '@/components/objects/Expand';

type GeometriProps = {
    vegobjekt: Vegobjekt;
    datakatalog: Datakatalog;
};

function Geometri({ vegobjekt, datakatalog }: GeometriProps) {
    const preferences = useSelector(statePreferences);
    const geometriVerdi = vegobjekt.egenskaper.filter(e =>
        e.navn?.startsWith('Geometri')
    );

    const geometriInformasjon = vegobjekt.egenskaper.find(
        e => e.egenskapstype.toLowerCase() === 'geometri'
    );
    const høydereferanse = geometriInformasjon?.høydereferanse;

    return (
        preferences.showGeometryInfo &&
        vegobjekt?.geometri?.egengeometri && (
            <>
                <hr />
                <h4 key="quality__subheader" className="c-valgt-features__subheader">
                    Geometri
                </h4>
                {geometriVerdi.map((geometri, index) => {
                    const matchingEgenskap = vegobjekt?.egenskaper.find(
                        egenskap =>
                            egenskap.erGeometri() && egenskap.navn === geometri.navn
                    );

                    const datafangstdato = matchingEgenskap?.datafangstdato;

                    return (
                        <React.Fragment key={`geometri-${index}`}>
                            <dt
                                key={`dt${geometri.verdi}`}
                                className="c-valgt-features__dt"
                                title={geometri.navn}
                            >
                                {geometri.navn}
                            </dt>
                            <dd
                                key={`dd${geometri.verdi}`}
                                className="c-valgt-features__dd"
                            >
                                <Expand text={String(geometri.verdi)} />

                                {matchingEgenskap?.kvalitet ? (
                                    renderQuality(matchingEgenskap.kvalitet, datakatalog)
                                ) : (
                                    <dd
                                        key="quality__dd-p"
                                        className="c-valgt-features__dd"
                                    >
                                        Geometrikvalitet ikke registrert
                                    </dd>
                                )}
                            </dd>

                            {datafangstdato && (
                                <>
                                    <dt
                                        key={`dt${datafangstdato}`}
                                        className="c-valgt-features__dt"
                                        title={'Datafangstdato'}
                                    >
                                        Datafangstdato
                                    </dt>
                                    <dd
                                        key={`dd-datafangstdato`}
                                        className="c-valgt-features__dd"
                                    >
                                        {datafangstdato}
                                    </dd>
                                </>
                            )}

                            {index < geometriVerdi.length - 1 && (
                                <div className="c-valgt-features__dotted-divider" />
                            )}
                        </React.Fragment>
                    );
                })}
                {høydereferanse !== undefined && (
                    <>
                        <dt
                            key={`dt${høydereferanse}`}
                            className="c-valgt-features__dt"
                            title={'Høydereferanse'}
                        >
                            Høydereferanse
                        </dt>
                        <dd key={`dd-høydereferanse`} className="c-valgt-features__dd">
                            {getHoydereferanseText(høydereferanse)}
                        </dd>
                    </>
                )}
            </>
        )
    );
}

function renderQuality(
    quality: VegobjektEgenskapKvalitetAttributt[],
    datakatalog: Datakatalog
) {
    const hiddenQualities = ['maksimaltAvvik'];
    return [...quality]
        .filter(k => !hiddenQualities.includes(k.name))
        .sort(VegobjektEgenskapKvalitetAttributt.comparator)
        .map(entry => {
            return [
                <dt
                    key={`dt${entry.name}`}
                    className="c-valgt-features__dt"
                    title={entry.displayName}
                >
                    {entry.displayName}
                </dt>,
                <dd key={`dd${entry.name}`} className="c-valgt-features__dd">
                    {interpretQuality(entry, datakatalog)}
                </dd>,
            ];
        });
}

export default Geometri;
